import React, { useEffect, useRef, useState } from 'react';
import {
  Menu,
  Form,
  Button,
  Space,
  Select,
  Input,
  Divider,
  Dropdown,
  message,
  Spin,
  Modal,
  Tooltip,
  InputRef,
} from 'antd';
import AttributeList from '../compontents/attribute-list';
import { Add, Close, More, EmptyFileColor } from 'patternx-svg';
import {
  addPreObject,
  copyPreObject,
  deletePreObject,
  getObjectList,
  getPreObjectInfo,
  publishPreObject,
  updatePreObject,
} from '../../../services/object-rule';
import { pick } from 'lodash';
import classNames from 'classnames';
import './index.less';
import PtxEmpty from '../../../components/ptx-empty';

let updated: boolean = false;
const RuleObject: React.FC<{}> = () => {
  const [objects, setObjects] = useState<any[]>([]);
  const [selectedKey, setSelectedKey] = useState<any>('');
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();
  const inputRef = useRef<InputRef>(null);
  const objectName = Form.useWatch('name', form);

  const refresh = () => {
    if (selectedKey?.isNew) {
      setObjects((prevState) => prevState.filter((item) => !item?.isNew));
      // setSelectedKey(objects?.[0]);
    } else if (updated) {
      const { id, name, conditionRelation, conditions } = selectedKey;
      form.setFieldsValue({
        id,
        conditionRelation,
        name,
        conditionDTOList: conditions.map((item: any) =>
          pick(item, ['id', 'compareKey', 'compareType', 'compareValue']),
        ),
      });
    }
  };

  // 取消
  const handleCancel = (cancelCallback?: any) => {
    if (updated) {
      Modal.confirm({
        title: `确认放弃本次${selectedKey?.isNew ? '新增' : '修改'}吗？`,
        content: selectedKey?.isNew ? '放弃后将不会新增此对象。' : '放弃后将不保留未保存的内容。',
        okText: '放弃',
        cancelText: '关闭',
        onOk() {
          updated = false;
          refresh();
          setTimeout(() => {
            cancelCallback?.();
          }, 100);
        },
        onCancel() {},
      });
    } else {
      refresh();
      setTimeout(() => {
        cancelCallback?.();
      }, 100);
    }

    return updated;
  };

  const handleAdd = () => {
    if (objects.find((item) => item.isNew)) {
      Modal.warning({
        title: '有未保存的新对象，请取消或保存后再新增',
        content: '',
      });
      return;
    }
    handleCancel(() => {
      const newObject = { id: 'new', name: '未命名对象', isNew: true };
      setObjects((prev) => [...prev, newObject]);
      setSelectedKey(newObject);
      inputRef.current!.focus({
        cursor: 'all',
      });
    });
  };

  const cancelAdd = () => {
    handleCancel(() => {
      setSelectedKey(objects?.[0]);
    });
  };

  const handleChecked = async (record: any, checked: boolean) => {
    const { success } = await publishPreObject({ preObjectId: record.id, published: checked });
    if (success) {
      if (checked) {
        message.success('发布成功');
      }
      setObjects(
        objects.map((item) =>
          item.id === record.id ? { ...item, checked, published: checked } : item,
        ),
      );
      if (record.id === selectedKey?.id) {
        setSelectedKey((prev: any) => ({ ...prev, published: checked }));
      }
    }
  };

  const handleSelect = (record: any) => {
    handleCancel(() => setSelectedKey(record));
  };

  // 加载预设对象列表
  const loadObject = async () => {
    setLoading(true);
    const { success, data } = await getObjectList();
    let newObjects = [];
    if (success && data?.details?.preObjectList) {
      newObjects = data.details.preObjectList?.map((item: any) => ({
        ...item,
        checked: item.published,
      }));
      setObjects(newObjects);
    }
    setLoading(false);

    return newObjects;
  };

  // 获取预设对象详情
  const getObjectInfo = async (obj: any) => {
    setLoading(true);

    let fields: any = {};
    if (obj.isNew) {
      fields = {
        id: '',
        conditionRelation: '所有',
        name: obj.name,
        conditionDTOList: [{ compareKey: '2', compareType: '包含', compareValue: '' }],
      };
    } else {
      const { success, data } = await getPreObjectInfo(obj.id);
      if (!success || !data?.details) {
        return;
      }
      const { id, name, conditionRelation, conditions } = data?.details;
      fields = {
        id,
        conditionRelation,
        name,
        conditionDTOList: conditions.map((item: any) =>
          pick(item, ['id', 'compareKey', 'compareType', 'compareValue']),
        ),
      };
    }

    form.setFieldsValue(fields);
    setLoading(false);

    return fields;
  };

  const addObject = async (values: any) => {
    setLoading(true);
    const { success, data } = await addPreObject(values);
    if (success) {
      message.success('保存成功');
      const res = await loadObject();
      if (data?.details?.id) {
        setSelectedKey(res.find((item: any) => item.id === data.details.id));
      }
    }
    setLoading(false);
  };

  const updateObject = async (values: any) => {
    setLoading(true);
    const { success } = await updatePreObject(values).catch(() => setLoading(false));
    if (success) {
      message.success('保存成功');
      const { name } = (await getObjectInfo({ id: selectedKey?.id })) || {};
      setSelectedKey((prev: any) => ({ ...prev, name }));
      setObjects((prevState) =>
        prevState.map((item) => (item.id === values.id ? { ...item, name } : item)),
      );
    } else {
      setLoading(false);
    }
  };

  const handleFinish = async (values: any) => {
    updated = false;
    if (values.id) {
      await updateObject(values);
    } else {
      await addObject(values);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    const { errorFields } = errorInfo || {};
    if (errorFields.some((error: any) => error.name[0] === 'conditionDTOList')) {
      message.error('有内容未填写');
    }
  };

  const onFieldsChange = () => {
    updated = true;
  };

  useEffect(() => {
    loadObject().then((res) => {
      if (res?.length > 0) {
        setSelectedKey(res[0]);
      }
    });
  }, []);

  useEffect(() => {
    if (!selectedKey?.id) {
      return;
    }
    getObjectInfo(selectedKey);
  }, [selectedKey?.id]);

  const handleSave = () => {
    form.submit();
  };

  const refreshObject = async () => {
    const res = await loadObject();
    if (!res.find((item: any) => item.id === selectedKey?.id)) {
      setSelectedKey(res?.[0]);
    }
  };

  const deleteObject = async (objId: string) => {
    Modal.confirm({
      title: `确认删除对象吗？`,
      content: `删除后所有规则将不可使用此对象，已应用此对象的规则可能出现缺失，请慎重操作。`,
      okText: '删除',
      okButtonProps: {
        type: 'primary',
        danger: true,
      },
      cancelText: '再想想',
      onOk: async () => {
        const { success } = await deletePreObject(objId);
        if (success) {
          await refreshObject();
        }
      },
      onCancel() {},
    });
  };

  const copyObject = async (objId: string) => {
    handleCancel(async () => {
      setLoading(true);
      const { success, data } = await copyPreObject(objId);
      if (success) {
        await refreshObject();
        setSelectedKey({ id: data?.details?.id, name: data?.details?.name });
      }
      setLoading(false);
    });
  };

  const dropdownOverlay = (item: any) => {
    return (
      <Menu style={{ width: 80 }}>
        <Menu.Item key="copy" onClick={() => copyObject(item.id)}>
          复制
        </Menu.Item>
        {!item?.published && (
          <Menu.Item key="delete">
            <div className="color-error" onClick={() => deleteObject(item.id)}>
              删除
            </div>
          </Menu.Item>
        )}
      </Menu>
    );
  };

  const compareKeys = [
    { label: '族类别名称', value: '1' },
    { label: '族名称', value: '2' },
    { label: '族类型', value: '3' },
  ];

  const compareTypes = [
    { label: '包含', value: '包含' },
    { label: '不包含', value: '不包含' },
    { label: '等于', value: '等于' },
  ];

  return (
    <Spin spinning={loading}>
      <div className="object-rule-wrap">
        <div className="page-header">对象管理</div>
        {objects?.length > 0 ? (
          <div className="page-content">
            <div className="page-content-left">
              <div className="attribute-header">
                <div className="attribute-header-title">预设对象</div>
                <Tooltip placement="top" title="新增对象">
                  <Add className="attribute-header-icon" onClick={handleAdd} />
                </Tooltip>
              </div>
              <AttributeList
                data={objects}
                selectedKey={selectedKey?.id}
                dropdownOverlay={dropdownOverlay}
                onChecked={handleChecked}
                onSelect={handleSelect}
              />
            </div>
            <div className="page-content-right">
              <div className="object-form-header">
                <span>{objectName || selectedKey?.name}</span>
                {selectedKey?.isNew ? (
                  <Space size={12}>
                    <Button key="cancelBtn" onClick={cancelAdd}>
                      取消
                    </Button>
                    <Button key="addSaveBtn" type="primary" onClick={handleSave}>
                      保存
                    </Button>
                  </Space>
                ) : (
                  <Space size={16} align="end">
                    <Button key="editSaveBtn" type="primary" onClick={handleSave}>
                      保存
                    </Button>
                    <Dropdown trigger={['click']} overlay={() => dropdownOverlay(selectedKey)}>
                      <More className="operate-more" />
                    </Dropdown>
                  </Space>
                )}
              </div>
              <Form
                form={form}
                name="object-form-nest-item"
                className="object-form-nest-item"
                onFinish={handleFinish}
                onFinishFailed={onFinishFailed}
                onFieldsChange={onFieldsChange}
                autoComplete="off"
              >
                <Form.Item name="id" hidden>
                  <Input placeholder="id" />
                </Form.Item>
                <div className="object-form-label">对象名称</div>
                <Form.Item name={'name'} rules={[{ required: true, message: '请输入名称' }]}>
                  <Input placeholder="请输入名称" maxLength={255} ref={inputRef} />
                </Form.Item>

                <Divider />

                <div style={{ marginBottom: 18 }}>
                  <Space>
                    <span>满足以下</span>
                    <Form.Item name="conditionRelation" className="object-form-no-margin">
                      <Select size="small" style={{ width: 72 }}>
                        <Select.Option value="所有">所有</Select.Option>
                        <Select.Option value="任一">任一</Select.Option>
                      </Select>
                    </Form.Item>
                    <span>条件：</span>
                  </Space>
                </div>

                <Form.List name="conditionDTOList">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <div key={key}>
                          <Form.Item name={[name, 'id']} hidden>
                            <Input placeholder="id" />
                          </Form.Item>
                          <Space
                            size={12}
                            className="object-form-conditions"
                            style={{ display: 'flex', marginBottom: 16 }}
                            align="end"
                          >
                            <Form.Item
                              {...restField}
                              className="object-form-no-margin"
                              name={[name, 'compareKey']}
                              rules={[{ required: true, message: '' }]}
                            >
                              <Select options={compareKeys} />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              className="object-form-no-margin"
                              name={[name, 'compareType']}
                              rules={[{ required: true, message: '' }]}
                            >
                              <Select options={compareTypes} />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              className="object-form-no-margin"
                              name={[name, 'compareValue']}
                              rules={[{ required: true, message: '' }]}
                            >
                              <Input placeholder="多个内容用逗号隔开，满足其一即可" />
                            </Form.Item>
                            <Close
                              className={classNames('close-icon', {
                                'close-icon-hidden': key === 0,
                              })}
                              onClick={() => remove(name)}
                            />
                          </Space>
                        </div>
                      ))}
                      <Button
                        className="object-form-add-btn"
                        type="link"
                        onClick={() =>
                          add({ compareKey: '2', compareType: '包含', compareValue: '' })
                        }
                        icon={<Add size={20} />}
                      >
                        添加条件
                      </Button>
                    </>
                  )}
                </Form.List>
              </Form>
            </div>
          </div>
        ) : (
          <PtxEmpty
            isEmpty={true}
            icon={<EmptyFileColor />}
            describe="没有对象"
            subDescribe="管理具有行业/企业共识的通用对象（例如停车位、机电管线、消防柜等），可以在规则库内被引用形成预置审查规则。"
            btnRender={() => (
              <Button type="primary" onClick={handleAdd}>
                新增对象
              </Button>
            )}
          />
        )}
      </div>
    </Spin>
  );
};

export default RuleObject;
